import { Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

import * as HttpStatus from 'http-status-codes';

import { Helper } from '../helper';
import { Constants } from '../constants';

const _ = require('underscore');

@Injectable()
export class MainService {
  API = this.helper.getApi();
  headerOptions = this.helper.buildAuthHeader();
  allTherapists: any;
  readonly clinicType = Constants.CLINIC_TYPE;

  constructor(
    private http: Http,
    public helper: Helper,
    private route: ActivatedRoute
  ) {}

  getTherapists(clinic: String, type: String): Observable<any> {
    let urlQuery = '?clinics=' + clinic;

    if (type === this.clinicType.custom) {
      this.route.queryParams.subscribe((params: Params) => {
        urlQuery = '';

        if (params['singleClinic'] === 'true') {
          urlQuery = '?clinics=' + params['clinics'];
        }

        if (params['superClinicId']) {
          urlQuery = '?clinics=' + params['superClinicId'];
        }
      });
    }

    return this.http.get(`${this.API}/api/physiotherapists` + urlQuery).pipe(
      map((response: Response) => {
        const result = response.json();

        if (type === this.clinicType.custom) {
          if (result.status === HttpStatus.OK) {
            this.allTherapists = result.response;

            localStorage.setItem(
              'allTherapists',
              JSON.stringify(result.response)
            );
          } else {
            console.error('Error', result);
          }
        } else {
          return result;
        }
      })
    );
  }

  getClinics(): Observable<any> {
    return this.http.get(`${this.API}/api/all-clinics`).pipe(
      map((response: Response) => {
        const result = response.json();

        if (result.status === HttpStatus.OK) {
          result.response.map((clinic) => {
            _.extend(clinic, { _id: clinic.id });
          });

          localStorage.setItem('allClinics', JSON.stringify(result.response));
          localStorage.setItem('clinics_status', JSON.stringify(result.status));

          return result.response;
        } else {
          console.error('Error', result);
        }
      })
    );
  }

  getServices(clinic: string, groupCode: string): Observable<any> {
    return this.http
      .get(
        `${this.API}/api/services?clinics=` + clinic + '&treatment=' + groupCode
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }

  getTimes(timesQuery: any): Observable<any> {
    return this.http
      .get(`${this.API}/api/available-times`, { params: timesQuery })
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/main.service.ts